define('services/auth/company',['require','exports','module'],function(require, exports, module) {
  "use strict";

  module.exports = function(config) {
    var get = function(callbackOk, callbackError, companyId) {
      $.ajax({
        method: "get",
        dataType: "json",
        url: [config.apiHost, "companies",  companyId || ""].join("/"),
        crossDomain: true,
        success: function(response) {
          if (callbackOk){
            callbackOk(response);
          }
        },
        error: function(err) {
          if (callbackError) {
            callbackError(err);
          }
        }
      });
    };
    return {
      get: get
    };
  };

});

